import {
  appendMarketingConsent,
  withMarketingConsentLine,
} from "./marketing-consent";
import { submitQuotationForm } from "./web3forms-quotation";

export interface DownloadGuide {
  id: string;
  title: string;
  description: string;
  pdfPath: string;
  filename: string;
  coverImage: string;
  sourcePath: string;
  pages: number;
  checkedAt: string;
}

export interface GuideRequest {
  name: string;
  email: string;
  company: string;
  marketingConsent: boolean;
}

export const whatsappClaudeGuide: DownloadGuide = {
  id: "whatsapp-claude-composio",
  title: "Send WhatsApp messages from Claude",
  description:
    "Follow 15 visual walkthroughs with clickable stages and task checkpoints. Set up Meta, check required verification, and prepare WhatsApp accounts and the API sender. Then use the WABA ID in Composio and Claude. Includes screen examples, costs, and troubleshooting.",
  pdfPath: "/downloads/whatsapp-business-api-claude-composio-guide.pdf?v=e1c43f91",
  filename: "Anchor-Sprint-WhatsApp-Business-API-Claude-Composio-Guide-Visual-Playbook.pdf",
  coverImage: "/images/guides/whatsapp-claude-composio-guide-cover.webp?v=e1c43f91",
  sourcePath:
    "/blog/whatsapp-business-api-malaysia-ban-safe-marketing-blast-ai/",
  pages: 41,
  checkedAt: "21 October 2026",
};

/** A download is unlocked only after the lead endpoint explicitly accepts it. */
export async function submitGuideRequest(
  values: GuideRequest,
  guide: DownloadGuide,
  accessKey: string | undefined,
  send: typeof fetch = fetch,
): Promise<void> {
  if (!accessKey || accessKey === "your_actual_web3forms_key_here") {
    throw new Error("The download form is not configured.");
  }
  if (!values.name.trim() || !values.email.trim()) {
    throw new Error("Name and email are required.");
  }
  const body = new FormData();
  body.set("access_key", accessKey);
  body.set("name", values.name.trim());
  body.set("email", values.email.trim());
  if (values.company.trim()) body.set("company", values.company.trim());
  body.set("subject", `Guide download: ${guide.title}`);
  body.set("from_name", "Anchor Sprint Website");
  body.set("request_type", "Download WhatsApp Claude Setup Guide");
  body.set("guide_id", guide.id);
  body.set("source", guide.sourcePath);
  body.set(
    "message",
    withMarketingConsentLine(
      `Requested guide: ${guide.title}`,
      values.marketingConsent,
    ),
  );
  appendMarketingConsent(body, values.marketingConsent, "en");
  await submitQuotationForm(body, send);
}
